<div class="loading">
    <section>
        <div class="loading-spinner"></div>
        <span>
            <span>{{ getDisplayText() }}</span>
        </span>
    </section>
</div>


